import React, { useState, useContext } from 'react';
import { Grid, TextField, DialogActions, Button, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';
import { AlertMessagesContext } from 'react-alert-messages';
import VariantService from 'services/VariantService';
import { useTranslation } from 'react-i18next';

export default function VariantCreateDialog({ open, handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [data, setData] = useState({ name: '' });
  const [isLoading, setLoading] = useState(false);
  const { postAlertMessage } = useContext(AlertMessagesContext);

  if (!open) return null;

  const handleCreateVariant = async () => {
    setLoading(true);
    try {
      const resp = await VariantService.createVariantDimension(data);
      handleSuccess(resp);
      handleClose();
      postAlertMessage({
        type: 'success',
        text: tPopup('Variant created successfully.'),
      });
    } catch (err) {
      postAlertMessage({
        type: 'error',
        text: err.message || tPopup('Failed to create variant.'),
      });
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Add Variant')}</h2>
            <IconButton onClick={handleClose} className={styles.closeBtn}>
              <CloseIcon />
            </IconButton>
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Variant Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Variant Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.name}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />
              </Grid>
            </Grid>

            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose} disabled={isLoading}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                disabled={!data.name.trim() || isLoading}
                onClick={handleCreateVariant}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" style={{ marginRight: '10px' }} />
                    {tCommon('Creating...')}
                  </>
                ) : (
                  tCommon('Create')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
